export default "__VITE_ASSET__Bss5roL2__"